import { Pipe, PipeTransform } from '@angular/core';
import { DEVICE_CALL_STATUS } from 'src/app/shared/models/Remote Operations/network-status';

//https://stackoverflow.com/questions/17380845/how-do-i-convert-a-string-to-enum-in-typescript
@Pipe({
  name: 'convertEnumToString'
})
export class NetworkStatusPipe implements PipeTransform {

  transform(enumNum: string, ...args: any[]): any {
    if (enumNum == null)
      return '';
    if (enumNum.length <= 0)
      return '';

    // To Enum / number
    var enumKey: DEVICE_CALL_STATUS = DEVICE_CALL_STATUS[enumNum];
    // To String
    //https://stackoverflow.com/questions/4775206/var-replace-is-not-a-function
    var newEnumVal = enumKey.toString(); //DEVICE_CALL_STATUS[DEVICE_CALL_STATUS.CALL_STATUS_IDLE];
    newEnumVal = newEnumVal.replace('Placing_', '');
    if (newEnumVal == 'Placing' || newEnumVal == 'Disconnecting')
      newEnumVal += "..";
    return newEnumVal;
  }

}




@Pipe({ name: 'dualUTA' })
export class DualUTAPipe implements PipeTransform {
  transform(value: string, args?: any): string {
    let repVal = "";
    if (value != null) {
      repVal = "<b>Firmware version: </b>" + (value.split('^'))[0].replace("DualUTA ", "") + " <b>Serial number: </b>" + (value.split('^'))[1];
      if (value.trim() == '^')
        repVal = "";
    }    
    return repVal;
  }
}


@Pipe({
  name: 'dateAndTimeRange'
})
export class DateAndTimeRangePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let repVal = value.replace(/Last /g, "");
    repVal = repVal.replace(/Hours/g, "Mins");
    repVal = repVal.replace(/Hour/g, "1 Hour");
    repVal = repVal.replace(/Mins/g, "Hours");
    repVal = repVal.replace(/Month/g, "1 Month");
    repVal = repVal.replace(/1 Months/g, "Months");//above month replace more replaced for 6 months
    repVal = repVal.replace(/Year/g, "1 Year");
    return repVal;
  }

}
